// resources/js/admin/components/shared/media/MediaList.tsx

import { Media } from "../../../types/features/Media";
import TableList, { SelectAction } from "../../ui/TableList";
import MediaRow from "./MediaRow";

interface MediaListProps {
    media: Media[];
    onAction: (media: Media) => void;
    onSelectMedia?: (selectedMedia: Media[]) => void;
    selectable?: boolean;
    selectActions?: SelectAction[];
    loading?: boolean;
    emptyMessage?: string;
}

export default function MediaList({
    media,
    onAction,
    onSelectMedia,
    selectable = false,
    selectActions,
    loading = false,
    emptyMessage = "Aucun média trouvé",
}: MediaListProps) {
        console.log("media" , media)

    const columns = [
        { header: "Fichier", className: "w-2/5" },
        { header: "Taille", className: "w-1/6" },
        { header: "Dimensions", className: "hidden sm:table-cell w-1/6" },
        { header: "Statut", className: "hidden md:table-cell w-1/6" },
        { header: "Aperçu", className: "hidden lg:table-cell w-1/6" },
        { header: "Ajouté le", className: "hidden xl:table-cell w-1/6" },
    ];

    if (loading) {
        return (
            <div className="flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
        );
    }

    return (
        <TableList
            items={media}
            columns={columns}
            getId={(item) => item.id}
            onAction={onAction}
            onSelectItems={onSelectMedia}
            selectable={selectable}
            emptyMessage={emptyMessage}
            actionColumn={true}
            selectActions={selectActions}
            renderRow={(item, isSelected, onSelect) => (
                <MediaRow
                    key={item.id}
                    media={item}
                    onAction={onAction}
                    onSelect={onSelect}
                    isSelected={isSelected}
                    selectable={selectable}
                />
            )}
        />
    );
}